var _0x3ea2e7 = _0x26bd;
(function (_0x38b019, _0x45e363) {
  var _0x399fcc = _0x26bd, _0x2dd538 = _0x38b019();
  while (!![]) {
    try {
      var _0x28f644 = -parseInt(_0x399fcc(0x1bf)) / 0x1 * (parseInt(_0x399fcc(0x1bc)) / 0x2) + parseInt(_0x399fcc(0x1b8)) / 0x3 * (-parseInt(_0x399fcc(0x1be)) / 0x4) + parseInt(_0x399fcc(0x1b3)) / 0x5 * (parseInt(_0x399fcc(0x1a1)) / 0x6) + -parseInt(_0x399fcc(0x1aa)) / 0x7 + -parseInt(_0x399fcc(0x1ab)) / 0x8 + parseInt(_0x399fcc(0x19d)) / 0x9 + parseInt(_0x399fcc(0x1af)) / 0xa;
      if (_0x28f644 === _0x45e363) break;
      else _0x2dd538['push'](_0x2dd538['shift']());
    } catch (_0x1cfa74) {
      _0x2dd538['push'](_0x2dd538['shift']());
    }
  }
}(_0x1348, 0x6d62e));

var lazy_css = [], lazy_js = [];

function _debounce(_0x570122, _0x14a53a = 0x12c) {
  let _0x5d58ae;
  return (..._0xd0fa43) => {
    clearTimeout(_0x5d58ae),
    _0x5d58ae = setTimeout(() => _0x570122['apply'](this, _0xd0fa43), _0x14a53a);
  };
}

function _0x1348() {
  var _0x4ca9c5 = ['lazy','IFRAME','564HuEHnA','src','DOMContentLoaded','setAttribute','replaceAll','loadBarInjector','__isPSA','innerHTML','href','1653295PVhhCJ','3465464AIvqAD','LINK','IMG',', function(){}','15474730WzFjya','CrOS','loading','x86_64','24595Qsgxcs','forEach','___mnag','type',', asyncLoad','267xQDzyd','nodeType','length','SCRIPT','926tvKGpH','plat','40228jsDyvj','514Zxoqxq','observe','documentElement','asyncLoad','gent','replace','includes','PreviewBarInjector','removeAttribute','if(window.attachEvent)','data-href','___mnag1','___plt','data-src','indexOf','tagName','2165490uxopJg','text/lazyload'];
  _0x1348 = function () { return _0x4ca9c5; };
  return _0x1348();
}

window[_0x3ea2e7(0x1b5)] = 'userA' + (window[_0x3ea2e7(0x198)] || '') + _0x3ea2e7(0x191),
window[_0x3ea2e7(0x199)] = _0x3ea2e7(0x1bd) + (window['___mnag1'] || '') + 'form';

try {
  var a = navigator[window[_0x3ea2e7(0x1b5)]],
      e = navigator[window[_0x3ea2e7(0x199)]];
  window[_0x3ea2e7(0x1a7)] = e[_0x3ea2e7(0x19b)](_0x3ea2e7(0x1b2)) > -0x1 && a['indexOf'](_0x3ea2e7(0x1b0)) < 0x0,
  window[_0x3ea2e7(0x1b5)] = '!1',
  c = null;
} catch (_0xe359f4) {
  window[_0x3ea2e7(0x1a7)] = !0x1;
  var c = null;
  window[_0x3ea2e7(0x1b5)] = '!1';
}

function _0x26bd(_0x1c7924, _0x510c07) {
  var _0x13488f = _0x1348();
  return _0x26bd = function (_0x26bddd, _0x14ea07) {
    _0x26bddd = _0x26bddd - 0x18e;
    var _0x4e698f = _0x13488f[_0x26bddd];
    return _0x4e698f;
  }, _0x26bd(_0x1c7924, _0x510c07);
}

window[_0x3ea2e7(0x1a7)] = __isPSA;

if (__isPSA)
var uLTS = new MutationObserver(_0x247759 => {
  var _0x535b01 = _0x3ea2e7;
  _0x247759[_0x535b01(0x1b4)](({ addedNodes: _0x3e913e }) => {
    var _0xc9b94a = _0x535b01;
    _0x3e913e[_0xc9b94a(0x1b4)](_0x8ca162 => {
      var _0x1f13a2 = _0xc9b94a;

      // ✅ ONLY CHANGE: no src removal
      0x1 === _0x8ca162[_0x1f13a2(0x1b9)] && _0x1f13a2(0x1a0) === _0x8ca162[_0x1f13a2(0x19c)] &&
      (_0x8ca162[_0x1f13a2(0x1a4)]('loading', _0x1f13a2(0x19f)));

      0x1 === _0x8ca162[_0x1f13a2(0x1b9)] && _0x1f13a2(0x1ad) === _0x8ca162[_0x1f13a2(0x19c)] &&
      ++imageCount > lazyImages && _0x8ca162[_0x1f13a2(0x1a4)]('loading', _0x1f13a2(0x19f));

      0x1 === _0x8ca162[_0x1f13a2(0x1b9)] && _0x1f13a2(0x1ac) === _0x8ca162[_0x1f13a2(0x19c)] &&
      lazy_css[_0x1f13a2(0x1ba)] && lazy_css[_0x1f13a2(0x1b4)](_0x3e9afd => {
        var _0x34ab12 = _0x1f13a2;
        _0x8ca162[_0x34ab12(0x1a9)][_0x34ab12(0x193)](_0x3e9afd) &&
        (_0x8ca162[_0x34ab12(0x1a4)](_0x34ab12(0x197), _0x8ca162[_0x34ab12(0x1a9)]),
        _0x8ca162[_0x34ab12(0x195)](_0x34ab12(0x1a9)));
      });
    });
  });
}),
imageCount = 0x0,
lazyImages = 0x14;

else
var uLTS = new MutationObserver(_0x413bef => {
  _0x413bef['forEach'](({ addedNodes: _0x455a96 }) => {
    _0x455a96['forEach'](_0x1058ab => {
      var _0x18f3dd = _0x26bd;

      // ✅ ONLY CHANGE: no src removal
      0x1 === _0x1058ab[_0x18f3dd(0x1b9)] && _0x18f3dd(0x1a0) === _0x1058ab[_0x18f3dd(0x19c)] &&
      (_0x1058ab[_0x18f3dd(0x1a4)]('loading', _0x18f3dd(0x19f)));

      0x1 === _0x1058ab[_0x18f3dd(0x1b9)] && _0x18f3dd(0x1ad) === _0x1058ab[_0x18f3dd(0x19c)] &&
      ++imageCount > lazyImages && _0x1058ab[_0x18f3dd(0x1a4)](_0x18f3dd(0x1b1), 'lazy');

      0x1 === _0x1058ab[_0x18f3dd(0x1b9)] && _0x18f3dd(0x1ac) === _0x1058ab[_0x18f3dd(0x19c)] &&
      lazy_css[_0x18f3dd(0x1ba)] && lazy_css[_0x18f3dd(0x1b4)](_0x191db1 => {
        var _0x478ed6 = _0x18f3dd;
        _0x1058ab[_0x478ed6(0x1a9)][_0x478ed6(0x193)](_0x191db1) &&
        (_0x1058ab[_0x478ed6(0x1a4)](_0x478ed6(0x197), _0x1058ab['href']),
        _0x1058ab[_0x478ed6(0x195)](_0x478ed6(0x1a9)));
      });
    });
  });
}),
imageCount = 0x0,
lazyImages = 0x14;

uLTS[_0x3ea2e7(0x18e)](document[_0x3ea2e7(0x18f)], {
  'childList': !0x0,
  'subtree': !0x0
});